export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2a3.5 3.5 0 013.5 3.5v.054a3.555 3.555 0 01-1.726 3.048L13 9.065v.877l9.266 5.737a2.606 2.606 0 01-1.371 4.821H3.105a2.606 2.606 0 01-1.37-4.821L11 9.942V8.5a1 1 0 01.485-.857l1.26-.756c.468-.281.755-.787.755-1.333V5.5a1.5 1.5 0 00-3 0V6h-2v-.5A3.5 3.5 0 0112 2zM2.787 17.38a.605.605 0 00.318 1.12h17.79a.606.606 0 00.318-1.12L12 11.676 2.787 17.38z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};